import React from 'react';
import s from './FunctionalButtonPanel.module.css';
import PanelButton from '../Buttons/PanelButton';
export type FunctionalButton = {
	name: string;
	value: string;
	link?: string;
	color?: string;
	func?: (value: string) => void;
	active?: boolean;
};

type Props = {
	functionality: FunctionalButton[];
	elWidth: string;
	callback?: (value: string) => void;
};
const FunctionalButtonPanel: React.FC<Props> = ({
	functionality,
	elWidth,
	callback,
}) => {
	return (
		<ul className={s.buttonsList}>
			{functionality.map((b, index) => (
				<li 
					key={index} 
					className={s.buttonsElement} 
					style={{
						flex: elWidth,
						'--index': index
					} as React.CSSProperties}
				>
					<span>
						<PanelButton
							name={b.name}
							type={'button'}
							color={b?.color === 'blue' ? b.color : 'brownButton'}
							onClickButton={() =>
								callback ? callback(b.value) : b.func ? b.func(b.value) : null
							}
							active={b.active}
						/>
					</span>
				</li>
			))}
		</ul>
	);
};

export default FunctionalButtonPanel;
